/**
 * Número de elementos por página en la tabla
 */
export const ITEMS_PER_PAGE = 10;

/**
 * Estado inicial de beneficiario (basado en el modelo real legal_entities)
 */
export const INITIAL_SUBCONTRACTOR_STATE = {
  uuid: null,
  cuit: '',
  legal_business_name: '',
  entity_type: 'provider',
  libb: '',
  is_intermediate_entity: '0',
  membership_fee: '0',
  company: '',
  address: '',
  uuid_district: '',
  postal_code: '',
  phone_number: '',
  email: '',
  observations: '',
  contact_information: '',
  is_collecting_entity: false,
  is_subcontractor: true,
  is_provider: true,
  is_active: true,
};

/**
 * Mensajes del sistema
 */
export const MESSAGES = {
  SUCCESS: {
    CREATE: 'Beneficiario creado exitosamente',
    UPDATE: 'Beneficiario actualizado exitosamente',
    DELETE: 'Beneficiario eliminado exitosamente',
  },
  ERROR: {
    CREATE: 'Error al crear el beneficiario',
    UPDATE: 'Error al actualizar el beneficiario',
    DELETE: 'Error al eliminar el beneficiario',
    REQUIRED_FIELD: 'Este campo es obligatorio',
    INVALID_CUIT: 'CUIT inválido',
    INVALID_EMAIL: 'Email inválido',
    INVALID_PHONE: 'Teléfono inválido',
  },
};

/**
 * Configuración de columnas de la tabla
 */
export const TABLE_COLUMNS = {
  company: { width: '20%' },
  cuit: { width: '15%' },
  legalBusinessName: { width: '20%' },
  address: { width: '15%' },
  contact: { width: '15%' },
  actions: { width: '15%' },
};
